package gr.tech.site.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import gr.tech.site.components.layouts.PageLayoutData
import gr.tech.site.components.sections.PartnersSectionWithHeaders
import gr.tech.site.styles.Theme
import gr.tech.site.styles.wideCappedWidth
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@InitRoute
fun initPartnersPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData(
        showContactHeader = true,
        title = "Our Partners & Suppliers",
        description = "Explore Green Rebates’ trusted utility and industry partners supporting energy rebate programs, LED lighting incentives, and efficiency upgrades for commercial horticulture operations.",
        canonicalUrl = "https://greenrebates.com/partners"
    ))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun PartnersPage() {
    Column(
        modifier = Modifier
            .wideCappedWidth()
            .classNames("mt-5", "mx-auto", "mb-5"),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        H1(
            Modifier.classNames("fs-1", "fw-bold", "w-full", "text-center", "mb-2")
                .toAttrs()
        ) {
            Text("Our Partners & Suppliers")
        }

        P(
            Modifier.classNames("fs-5", "text-center", "mb-4", "w-75")
                .color(Theme.DarkGreen.rgb)
                .opacity(0.8)
                .toAttrs()
        ) {
            Text("Green Rebates works alongside trusted utility providers and industry partners to deliver reliable energy rebate programs and efficiency incentives for commercial and controlled-environment facilities. Through these partnerships, we help streamline access to LED lighting rebates, HVAC incentives, and horticulture-focused programs designed to support smarter upgrades and long-term operational performance.")
        }

        HorizontalDivider(modifier = Modifier.classNames("my-4"))

        PartnersSectionWithHeaders()
    }
}